import {
  LISTING_CATEGORIES,
  LISTING_TYPES,
} from '../../containers/EditListingPage/listingTypeConfig';
import css from './OrderPanel.module.css';
import classNames from 'classnames';
import { getListingCategory } from '../../containers/EditListingPage/listingTypeUtils';
import { parseBoolean } from '../../containers/ListingPage/listingFieldUtils';
import { Fragment } from 'react';
import { formatMinorUnitsToGBP } from '../../util/currency';
import { Highlight } from '@chakra-ui/react';

const PriceSection = ({ formattedPrice, currentListing, isListingCard = false }) => {
  const classes = classNames('', {
    [css.priceContainerDesktop]: !isListingCard,
    [css.priceContainerInListingCard]: isListingCard,
  });

  const priceSection = getPriceSection(classes, currentListing, formattedPrice);

  return (
    <Fragment>
      <span className={classes}>{priceSection}</span>
      {!isListingCard && <DropInPriceMaybe currentListing={currentListing} />}
    </Fragment>
  );
};

const getPriceSection = (classes, currentListing, formattedPrice) => {
  if (
    currentListing?.attributes?.price?.amount === 0 &&
    parseBoolean(currentListing?.attributes?.publicData?.dropInAvailable) &&
    currentListing?.attributes?.publicData?.listingType === LISTING_TYPES.PERSONAL_TRAINER
  ) {
    return 'Members only trainer';
  } else if (
    currentListing?.attributes?.price?.amount === 0 &&
    parseBoolean(currentListing?.attributes?.publicData?.isIncludedWithMembership) &&
    currentListing?.attributes?.publicData?.listingType === LISTING_TYPES.CLASS
  ) {
    return (
      <Highlight
        query="Included with membership"
        styles={{ fontWeight: '550', bg: 'none', color: 'brand.600' }}
      >
        Included with membership
      </Highlight>
    );
  } else if (
    currentListing?.attributes?.price?.amount === 0 &&
    getListingCategory(currentListing) === LISTING_CATEGORIES.SPORTS_CLUB
  ) {
    return (
      <Highlight query="membership" styles={{ fontWeight: '550', bg: 'none' }}>
        Message to join
      </Highlight>
    );
  }

  return getPriceUnit(currentListing, formattedPrice);
};

const getPriceUnit = (currentListing, formattedPrice) => {
  if (formattedPrice === '£0') {
    if (currentListing?.attributes?.publicData?.isIncludedWithMembership) {
      return 'Included with membership';
    }
    return 'Free';
  }

  switch (getListingCategory(currentListing)) {
    case LISTING_CATEGORIES.GYM:
      return (
        <Highlight
          query={formattedPrice}
          styles={{ fontWeight: 'semibold', bg: 'none', fontSize: 'md' }}
        >{`From ${formattedPrice} / month`}</Highlight>
      );
    case LISTING_CATEGORIES.CLASS:
      return (
        <Highlight
          query={formattedPrice}
          styles={{ fontWeight: 'semibold', bg: 'none', fontSize: 'md' }}
        >{`${formattedPrice} / class`}</Highlight>
      );
    case LISTING_CATEGORIES.SPORTS_CLUB:
      return (
        <Highlight
          query={formattedPrice}
          styles={{ fontWeight: 'semibold', bg: 'none', fontSize: 'md' }}
        >{`From ${formattedPrice} / month`}</Highlight>
      );
    case LISTING_CATEGORIES.PERSONAL_TRAINER:
      return (
        <Highlight
          query={formattedPrice}
          styles={{ fontWeight: 'semibold', bg: 'none', fontSize: 'md' }}
        >{`${formattedPrice} / session`}</Highlight>
      );
  }
};

const DropInPriceMaybe = ({ currentListing }) => {
  if (!currentListing?.attributes?.publicData) return null;

  const { dropInPrice, dropInAvailable } = currentListing?.attributes?.publicData;
  if (!!dropInPrice && dropInAvailable) {
    return (
      <div className={css.dropInPriceSection}>
        <small>
          or <strong> {formatMinorUnitsToGBP(dropInPrice.amount)}</strong> to drop in
        </small>
      </div>
    );
  }
  return null;
};
export default PriceSection;
